module.exports = __webpack_public_path__ + "assets/img/mobile.cbcb90bf.svg";